import React from 'react'
import { Link } from 'react-router-dom'
import { formatPrice } from '../../Utils/UtilsPricesFormat'

export default function InvoicesSections({ invoices }) {
    return (
        <div className='col-span-full xl:col-span-12'>
            <h4 className="text-gray-800 dark:text-gray-100 font-bold my-4 ce5fk">
                Versemants Recents <span className="cmpw7 cdqku c1k3n">{invoices.length}</span>
            </h4>
            <div className='grid-cols-12 gap-6 grid'>
                
                {invoices.map(invoice => (

                    <Link key={invoice.id} to={`/dashboard/factures/events/invoices/show-details/i/${invoice.event_id}`} className='cgnhv c33r0 cvwie c2vpa ci500 cdjoa coz6m rounded-xl c5vqk'>
                        <div className="">
                            <div className="flex cydwr cetff cav8x csusu">
                                <div className="cu6vl cbw8w">
                                    <h3 className="text-gray-900 font-bold text-sm dark:text-gray-100 cgulq c7x0x cu6vl">
                                    Versement N° {invoice.invoice_number}
                                    </h3>
                                    <div className="font-semibold c612e cydwr">{formatPrice(invoice.to_pay)}</div>
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
            <div
                className="z-10 relative flex items-end text-neutral-900 dark:text-neutral-300 justify-end my-5"
                >
                <Link to={'/dashboard/factures/mes-factures/liste'}
                    className="bg-white text-xs font-semibold px-2 py-1 dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-6000 dark:hover:border-neutral-500 rounded-lg flex items-center justify-center hover:border-neutral-300 focus:outline-none"
                    data-glide-dir="▶"
                >
                    Voir tous
                    <i className="las la-angle-right" />
                </Link>
            </div>
        </div>
    )
}
